/* hp26 header nav (DRAFT only): desktop mega menu (hover intent + click, Esc, focusout) and mobile drawer accordion. */
(function(){
  var nav=document.querySelector('[data-hp26-hn]'); if(!nav||nav.dataset.ready) return; nav.dataset.ready='1';
  var mq=window.matchMedia('(min-width:1200px)');
  var drawer=nav.querySelector('[data-hp26-hn-drawer]'), scrim=nav.querySelector('[data-hp26-hn-scrim]');
  var burger=nav.querySelector('[data-hp26-hn-open]'), closeBtn=nav.querySelector('[data-hp26-hn-close]');
  var items=[].slice.call(nav.querySelectorAll('[data-hp26-hn-item]'));
  var openTimer,closeTimer;
  function tog(li){return li.querySelector('.hp26-hn__tog');}
  function panel(li){return document.getElementById(tog(li).getAttribute('aria-controls'));}
  function setItem(li,open){var b=tog(li);b.setAttribute('aria-expanded',open?'true':'false');panel(li).hidden=!open;li.classList.toggle('is-open',open);}
  function closeAll(except){items.forEach(function(li){if(li!==except&&li.classList.contains('is-open'))setItem(li,false);});}
  function openItem(li){if(mq.matches)closeAll(li);setItem(li,true);}
  items.forEach(function(li){
    var b=tog(li);
    b.addEventListener('click',function(){var o=b.getAttribute('aria-expanded')==='true';if(o)setItem(li,false);else openItem(li);});
    li.addEventListener('pointerenter',function(e){if(!mq.matches||e.pointerType==='touch')return;clearTimeout(closeTimer);clearTimeout(openTimer);
      openTimer=setTimeout(function(){openItem(li);},nav.querySelector('.hp26-hn__item.is-open')?0:120);});
    li.addEventListener('pointerleave',function(e){if(!mq.matches||e.pointerType==='touch')return;clearTimeout(openTimer);
      closeTimer=setTimeout(function(){setItem(li,false);},200);});
  });
  /* desktop: close when focus leaves the nav */
  nav.addEventListener('focusout',function(e){if(!mq.matches)return;if(!nav.contains(e.relatedTarget))closeAll();});
  document.addEventListener('click',function(e){if(mq.matches&&!nav.contains(e.target))closeAll();});
  /* mobile drawer */
  var lastFocus=null;
  function focusables(){return [].slice.call(drawer.querySelectorAll('a[href],button:not([disabled])')).filter(function(el){return el.offsetParent!==null;});}
  function openDrawer(){lastFocus=document.activeElement;nav.classList.add('is-open');scrim.hidden=false;burger.setAttribute('aria-expanded','true');
    drawer.setAttribute('role','dialog');drawer.setAttribute('aria-modal','true');drawer.setAttribute('aria-label','Main menu');
    document.documentElement.classList.add('hp26-hn-lock');setTimeout(function(){closeBtn.focus();},30);}
  function closeDrawer(){if(!nav.classList.contains('is-open'))return;nav.classList.remove('is-open');scrim.hidden=true;burger.setAttribute('aria-expanded','false');
    drawer.removeAttribute('role');drawer.removeAttribute('aria-modal');drawer.removeAttribute('aria-label');
    document.documentElement.classList.remove('hp26-hn-lock');(lastFocus&&lastFocus.focus?lastFocus:burger).focus();}
  burger.addEventListener('click',openDrawer);closeBtn.addEventListener('click',closeDrawer);scrim.addEventListener('click',closeDrawer);
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      if(nav.classList.contains('is-open')){closeDrawer();return;}
      var o=nav.querySelector('.hp26-hn__item.is-open');if(o){setItem(o,false);tog(o).focus();}
    } else if(e.key==='Tab'&&nav.classList.contains('is-open')){
      var f=focusables();if(!f.length)return;var first=f[0],last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    }
  });
  function onBp(){closeAll();closeDrawer();}
  if(mq.addEventListener)mq.addEventListener('change',onBp);else mq.addListener(onBp);
})();
